import type { FunctionComponent } from 'react';
import type { TypeTextChildProps } from './types';

export const Pretitle: FunctionComponent<TypeTextChildProps> = ({
  className = '',
  color,
  children,
}: TypeTextChildProps): JSX.Element => (
  <div
    className={`u-actions u-actions--chips ${className}`}
    style={{ color: color }}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);
